import Section from '@repo/ui/src/components/Section';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import buildLinkObj from '@repo/ui/src/functions/build-link';
import { LinkProps } from '@repo/ui/src/types/link';
import { classNames } from '@repo/ui/src/utils/classNames';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Markdown from '@repo/ui/src/components/Markdown';
import Accordion, { AccordionItem } from '@repo/ui/src/components/Accordion';

interface Props {
  title?: string;
  description: string;
  overlappingCard?: boolean;
  faqs: Array<{
    description: string;
    link: LinkProps;
    title: string;
  }>;
  _testID: string;
}

export type ID = string | number;

const FaqAccordion = ({ title, description, faqs, overlappingCard, _testID }: Props) => {
  if (!faqs) return null;
  return (
    <Section
      basePadding
      gutterX
      gutterY
      monetateTestId={`faq_accordion_${_testID}`}
      className="tw-bg-warm-200"
    >
      <div className="tw-bg-white">
        <Section white gutterX gutterY basePadding>
          <div
            className={classNames(
              'tw-flex tw-flex-col md:tw-grid md:tw-grid-cols-[1fr_2fr] lg:tw-grid-cols-2',
              overlappingCard ? 'tw-pb-10' : 'tw-pb-0',
            )}
          >
            <div className="tw-mb-4 tw-mr-12 lg:tw-max-w-[25rem]">
              <ToutContent
                heading={title}
                headingStyleVariant="h2"
                description={description}
                divider
                align="left"
              />
            </div>

            <Accordion preExpanded={[faqs?.[0]?.title as ID]}>
              {faqs?.map((item) => {
                const linkObj = item?.link?.link ? buildLinkObj(item.link) : null;
                return (
                  <AccordionItem
                    key={`base_accordion_${item.title}`}
                    heading={item.title}
                    uuid={item.title}
                    className="tw-px-4"
                  >
                    <Markdown className="tra-text-web-body-l tw-mt-2 tw-normal-case">
                      {item.description}
                    </Markdown>
                    {linkObj && <Anchor link={linkObj.href}>{linkObj.text}</Anchor>}
                  </AccordionItem>
                );
              })}
            </Accordion>
          </div>
        </Section>
      </div>
    </Section>
  );
};

export default FaqAccordion;
